// extracted by mini-css-extract-plugin
module.exports = {"formField":"lecture-task-form_formField__VklvM","formControl":"lecture-task-form_formControl__9TaAR"};